import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../redux/baseQuery";

export const blackListCardApi = createApi({
  reducerPath: "blackListCardApi",
  baseQuery,
  tagTypes: ["BlackListCard"],

  endpoints: (builder) => ({
    getBlackListCard: builder.query({
      query: (params) => ({
        url: "blacklist-card/get",
        method: "GET",
        params,
      }),
      providesTags: ["BlackListCard"],
    }),

    createBlacklistCard: builder.mutation({
      query: (body) => ({
        url: "blacklist-card/create",
        method: "POST",
        body,
      }),
      invalidatesTags: ["BlackListCard"],
    }),
    
    deleteBlackListCard: builder.mutation({
      query: (cardNumber) => ({
        url: "blacklist-card/delete",
        method: "DELETE",
        body: {
          cardNumber,
        },
      }),
      invalidatesTags: ["BlackListCard"],
    }),
  }),
});

export const {
  useGetBlackListCardQuery,
  useCreateBlacklistCardMutation,
  useDeleteBlackListCardMutation,
} = blackListCardApi;
